import { Button } from "@material-ui/core";
import { Plus } from "phosphor-react";
import React from "react";
import Loader from "../../../../Utilities/Loader/Loader";
import NoResultFound from "../../../../Utilities/NoResultFound/NoResultFound";
import SinglePhaseCard from "./SinglePhaseCard.component";
import useStyles from "./ManageTaskPhasesComponent.style";
import { fpatch } from "../../../../../API/callsAPI";

const ManageTaskPhasesComponent = ({
  phases,
  departments,
  handleEditTaskPhaseInfo,
  handleDeleteTaskPhaseInfo,
  setIsNewTaskPhaseModalOpen,
  isLoaded,
  closeManagePhaseModal,
  setPhases,
  setSnackValue,
}) => {
  const classes = useStyles();
  const updateNextPhase = (phaseId, nextPhases) => {
    setPhases((prevPhases) =>
      prevPhases.map((phase) =>
        phase.id === phaseId ? { ...phase, next_rels: nextPhases } : phase
      )
    );
  };

  const handleUpdatePhases = async () => {
    try {
      const updateData = phases
        ?.filter((phase) => phase?.next_rels?.length > 0)
        .map((sin) => {
          if (sin?.next_rels?.length > 0) {
            return {
              id: sin.id,
              next_rels: sin?.next_rels,
            };
          }
        });
      let updatedPhases = {
        url: `bulk-update-phase/`,
        data: updateData,
      };
      await fpatch(updatedPhases);
      setSnackValue({
        isOpen: true,
        message: `phases updated successfully`,
        isError: false,
      });
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  return (
    <div style={{ height: "90%" }}>
      <div style={{ height: "87%", overflowY: "auto" }}>
        {isLoaded ? (
          <>
            {phases?.length > 0 ? (
              <div>
                {phases.map((singlePhase, index) => {
                  return (
                    <SinglePhaseCard
                      serial={index}
                      key={singlePhase?.id}
                      singlePhase={singlePhase}
                      departments={departments}
                      handleEditTaskPhaseInfo={handleEditTaskPhaseInfo}
                      handleDeleteTaskPhaseInfo={handleDeleteTaskPhaseInfo}
                      phases={phases}
                      updateNextPhase={updateNextPhase}
                    />
                  );
                })}
              </div>
            ) : (
              <div className={classes.noResultDiv}>
                <NoResultFound />
              </div>
            )}
          </>
        ) : (
          <Loader />
        )}
        <div
          className={classes.addNewPhaseButton}
          onClick={() => {
            setIsNewTaskPhaseModalOpen(true);
          }}
        >
          <div>
            <Plus /> <span>Add New Task Phase</span>
          </div>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <Button
          className={classes.doneButton}
          onClick={() => handleUpdatePhases()}
        >
          <span>Apply Changes</span>
        </Button>
      </div>
    </div>
  );
};

export default ManageTaskPhasesComponent;
